import React, { useEffect, useState } from 'react'
import Cleave from 'cleave.js/react';

import EspecialidadesService from '../../../../services/especialidades-service'
import ProcedimentosService from '../../../../services/procedimentos-service'
import CalculoService from '../../../../services/calculo-service'
import searchIcon from '../../../../images/search-icon.png'

import error from '../autorizacaoGuias/images/archive.png'

const ConsultaCoparticipacoes = (props) => {
    const [loadingCalculo, setLoadingCalculo] = useState(false)
    const [loadingProcedimento, setLoadingProcedimento] = useState(false)
    const [loadingEspecialidades, setLoadingEspecialidades] = useState(false)
    const [didError, setDidError] = useState(false)
    const [errorsForm, setErrorsForm] = useState([])
    const [especialidades, setEspecialidades] = useState([])
    const [carteira, setCarteira] = useState("")
    const [carteiraRaw, setCarteiraRaw] = useState("")
    const [nascimento, setNascimento] = useState("")
    const [especialidade, setEspecialidade] = useState("")
    const [search, setSearch] = useState("")
    const [procedimentos, setProcedimentos] = useState([])
    const [procedimento, setProcedimento] = useState("")
    const [resultadoCalculo, setResultadoCalculo] = useState("")

    useEffect(() => {
        async function getEspecialidades() {
            setLoadingEspecialidades(true)
            const especialidades = await EspecialidadesService.getEspecialidades()
            setLoadingEspecialidades(false)
            if (especialidades.status) {
                setEspecialidades(especialidades.especialidades)
            }
            else {
                if (especialidades.error) {
                    setDidError(true)
                }
            }
        }
        getEspecialidades()

    }, [])

    useEffect(() => {
        window.parent.postMessage('change', window.location.origin)
    });



    const getProcedimentos = async () => {
        if (validateSearch()) {
            return
        }
        setLoadingProcedimento(true)
        const procs = await ProcedimentosService.getProcedimentos(especialidade, search)
        setLoadingProcedimento(false)
        if (procs.status) {
            setProcedimentos(procs.procedimentos)
        }
        else {
            if (procs.error) {
                setDidError(true)
            }
        }
    }

    const calcular = async () => {
        if (validateForm()) {
            return
        }
        setLoadingCalculo(true)
        const calculo = await CalculoService.calcular(carteiraRaw, procedimento)
        setLoadingCalculo(false)
        if (calculo.status) {
            setResultadoCalculo(calculo.html)
        }
        else {
            if (calculo.error) {
                setDidError(true)
            }
        }
    }

    const renderEspecialidades = () => {
        return (especialidades.map(e => {
            return <option key={e.codesp} value={e.codesp}>{e.descricao}</option>
        }))
    }

    const renderProcedimentos = () => {
        if (loadingProcedimento) {
            return (<div className="lds-ring"><div></div><div></div><div></div><div></div></div>)
        }
        return procedimentos.map((e, index) => {
            return (<tr className={`rowProc ${procedimento === e.codpro ? "selected" : ""} `} key={index} onClick={() => setProcedimento(e.codpro)} ><td style={{ fontWeight: procedimento === e.codpro ? 'bold' : 'normal', padding: "0 1rem", borderLeft: "1px solid", cursor: "pointer" }}> {e.codpro}</td><td style={{ fontWeight: procedimento === e.codpro ? 'bold' : 'normal', padding: "0 1rem", borderLeft: "1px solid", cursor: "pointer" }}>{e.descricao}</td></tr>)
        })
    }

    const renderValidation = (field) => {
        const error = errorsForm.filter(e => e.field === field)
        if (!error.length) {
            return null
        }
        return (<div className="validation-message">{error[0].message}</div>)
    }

    const renderError = () => {
        if (didError) {
            return (
                <div className="not-found-wrapper">
                    <img src={error} alt="Erro" />
                    <h5>Ocorreu um erro</h5>
                    <p>
                        Um erro ocorreu ao processar sua consulta. Por favor tente
                        novamente.
                    </p>
                    <p>
                        Se esta mensagem for recorrente, entre em contato com o suporte.
                    </p>
                </div>
            );
        }
        return null;
    };

    const handleCarteiraChange = e => {
        setCarteira(e.target.value)
        setCarteiraRaw(e.target.rawValue)
    }

    const validateForm = () => {
        const errors = []
        if (carteiraRaw.length === 0) {
            errors.push({ field: 'carteira', message: 'Preencha sua carteira' })
        }
        else {
            if (carteiraRaw.length !== 17) {
                errors.push({ field: "carteira", message: "Verifique sua carteira, ela deve conter 17 dígitos" })
            }
            if (carteira.substr(0, 5) !== '0 055') {
                errors.push({ field: "carteira", message: "Somente disponível para clientes Unimed VS" })
            }
        }
        if (nascimento.length !== 10) {
            errors.push({ field: "nascimento", message: "Verifique sua data de nascimento" })
        }

        if (!procedimento) {
            errors.push({ field: "procedimento", message: "Escolha um procedimento" })
        }
        setErrorsForm(errors)
        return errors.length
    }

    const validateSearch = () => {
        const errors = []
        if (carteiraRaw.length === 0) {
            errors.push({ field: 'carteira', message: 'Preencha sua carteira' })
        }
        else {
            if (carteiraRaw.length !== 17) {
                errors.push({ field: "carteira", message: "Verifique sua carteira, ela deve conter 17 dígitos" })
            }
        }
        if (!especialidade && !search) {
            errors.push({ field: "search", message: "Preencha algum dos filtros para a busca" })
        }
        setErrorsForm(errors)
        return errors.length
    }

    return (
        <section className={`consulta-copart txt8 lh-1 ${props.hide ? 'hide' : ''}`}>
            <h2 className="txt-laranja ">Consulta de coparticipações</h2>
            Agora você pode consultar o valor de coparticipação para consultas, exames e terapias (fisioterapia, fonoaudiologia, psicologia e nutrição) através do site.
            <br /><br />
            Para realizar a consulta, basta preencher o número da carteira do beneficiário e a data de nascimento.
            Você pode localizar o procedimento filtrando por especialidade ou palavra-chave, após selecione o procedimento clicando sobre o mesmo.
            <br /><br />
            Para procedimentos médicos, cirúrgicos ou internações, entre em contato através do 0800 642 1800 ou pessoalmente em um dos nossos postos de atendimento.

            <h3 className="txt-verde">Informe os campos abaixo</h3>
            <div className="box-passos">
                <div className="linha-form"><div>Carteira do beneficiário</div><div> <Cleave type={'ontouchstart' in document.documentElement ? "tel" : "text"} id="carteira" name="carteira" value={carteira} options={{ blocks: [1, 3, 12, 1], delimiter: ' ', numericOnly: true }} onChange={handleCarteiraChange} />  {renderValidation("carteira")}</div></div>

                <div className="linha-form" style={{ borderBottom: "1px solid white" }}><div>Data de nascimento</div><div><Cleave type={'ontouchstart' in document.documentElement ? "tel" : "text"} options={{ date: true, datePattern: ['d', 'm', 'Y'] }} onChange={e => setNascimento(e.target.value)} /> {renderValidation("nascimento")} </div></div>

                <div className="linha-form"><div>Especialidade</div> <div>
                    <select id="especialidades" name="especialidades" value={especialidade} onChange={e => setEspecialidade(e.target.value)}>
                        <option value=""> </option>
                        {renderEspecialidades()}
                    </select></div></div>
                {loadingEspecialidades ?
                    <div className="lds-ring small-ring"><div></div><div></div><div></div><div></div></div>
                    : null}
                <div className="linha-form" style={{ borderBottom: "1px solid white" }}><div>Palavra chave ou procedimento</div>
                    <div style={{display: 'flex', flexDirection: 'row', gap: '15px', alignItems: 'center'}}>
                        <input type="text" maxLength="300" style={{ width: "90%" }} value={search} onChange={e => setSearch(e.target.value)} />
                        <img onClick={() => getProcedimentos()}  src={searchIcon} alt='Busca'></img>
                        {/* <button onClick={() => getProcedimentos()} type='button'>
                        </button> */}
                        {/* <i className="fa fa-search fa-lg link" onClick={() => getProcedimentos()}></i> */}
                        {renderValidation("search")}
                    </div>
                </div>

                <div className="linha-form"><div>Selecione o procedimento</div>
                    <div>
                        <div style={{ width: "100%", backgroundColor: "white", height: "150px", overflow: "auto" }}>
                            {renderProcedimentos()}
                        </div>
                        {renderValidation("procedimento")}
                    </div>
                </div>

                <div className="linha-form"><div></div><div><button className="btn" onClick={() => calcular()}>Simular cálculo</button></div></div>
                {loadingCalculo ?
                    <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
                    : null}
                {renderError()}
                <div dangerouslySetInnerHTML={{ __html: resultadoCalculo }}></div>

            </div>
        </section>
    )
}

export default ConsultaCoparticipacoes;